import { c as _c } from "react/compiler-runtime";
import { MENTOR_REPLY_TIME } from '@algoacademy/backend/modules/marketplace/enums';
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { BadgeButton } from '@algoacademy/design-system/web/data-display/Badge';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
type MentorReplyTimeProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: Partial<AdvancedMentoringProductDTO>) => void;
};
export function MentorReplyTime(t0) {
  const $ = _c(5);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const mentorReplyTime = advancedMentoringProduct.mentorReplyTime;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4 className="font-medium">Czas oczekiwania na odpowiedź mentora</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(MENTOR_REPLY_TIME);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mentorReplyTime || $[3] !== updateProduct) {
    t3 = <IconOnTheLeftWithContentLayout mainContent={t1}><div className="flex flex-row flex-wrap gap-2">{t2.map(option => <BadgeButton key={option} color={mentorReplyTime === option ? "blueInverted" : "secondary"} onClick={() => updateProduct({
          mentorReplyTime: option
        })}>{option === MENTOR_REPLY_TIME.STANDARD ? `${option} (standard)` : option}</BadgeButton>)}</div></IconOnTheLeftWithContentLayout>;
    $[2] = mentorReplyTime;
    $[3] = updateProduct;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}